module.exports = __webpack_public_path__ + "img/configuration.5def7dbc.png";